export const reportTypes = {
  KV_Fleet_Report: '0MM01FJG4EM12',
  KV_Vehicle_Report: '0MKZQ95R2YNMR',
  KV_Transportation_Report: '0MKNETC36XP4Y',
};
